
import React from 'react';
import Sidebar from '@/components/Sidebar';
import Header from '@/components/Header';

const Default = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar collapsed={sidebarCollapsed} onToggle={toggleSidebar} />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header onToggleSidebar={toggleSidebar} />
        
        <main className="flex-1 overflow-x-hidden overflow-y-auto p-4">
          <h1 className="text-2xl font-bold mb-6">Default Dashboard</h1>
          
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <p className="text-lg text-gray-600">
              Welcome to the Default Dashboard page. This is a placeholder that you can customize with your preferred content.
            </p>
          </div>
        </main>
        
        <footer className="bg-white p-4 text-center text-gray-500 text-sm border-t">
          Copyright © 2025. All right reserved.
        </footer>
      </div>
    </div>
  );
};

export default Default;
